/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://ke57ufvemnbc3hytzmhvdlseui.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-b4izrwcysvcgfg5f55slcaxkzq",
    "aws_cloud_logic_custom": [
        {
            "name": "stripeapi",
            "endpoint": "https://qundtiybt6.execute-api.us-east-1.amazonaws.com/test",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:25648786-5c6e-47ec-801f-205b774a22f6",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_NcaUvdJqw",
    "aws_user_pools_web_client_id": "52geqaue4gh0c51qa2lct2kt0e",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "medstock-staging6ca08-test",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
